import { useEffect, useReducer } from 'react';
import getAuthClient from 'Core_Helpers/getAuthClient';

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_INIT':
      return { ...state, isLoading: true, isError: false };
    case 'SUBMIT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        errorMessage: '',
        response: action.payload,
      };
    case 'SUBMIT_FAILURE':
      return {
        ...state,
        isLoading: false,
        hasErrored: true,
        errorMessage: 'Data Submission Failed',
      };
  }
};

const useAxiosPatch = (url, data, delay = 0) => {
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    hasErrored: false,
    errorMessage: '',
    response: null,
  });

  useEffect(() => {
    let didCancel = false;

    const submitData = async () => {
      dispatch({ type: 'SUBMIT_INIT' });

      try {
        const authorizedApi = await getAuthClient();
        const response = await authorizedApi.patch(url, data);
        if (!didCancel) {
          setTimeout(() => {
            dispatch({ type: 'SUBMIT_SUCCESS', payload: response });
          }, delay - response.responseTime);
        }
      } catch (err) {
        if (!didCancel) {
          dispatch({ type: 'SUBMIT_FAILURE' });
        }
      }
    };

    if (data) {
      submitData();
    }

    return () => {
      didCancel = true;
    };
  }, [data]);

  return { ...state };
};

export default useAxiosPatch;
